module.exports = __webpack_public_path__ + "static/media/accident.b72aa583.svg";